import React, { Component } from "react";
import Button from "react-bootstrap/Button";
import styles from "./portfolioCard.module.css";

class PortfolioCard extends Component {
  state = {};

  render() {
    /* const styles = {
      container: {
        position: "relative",
        width: "100%",
        maxWidth: "400px"
      },
      image: {
        display: "block",
        width: "100%",
        height: "auto"
      },
      overlay: {
        position: "absolute",
        top: "0",
        bottom: "0",
        left: "0",
        right: "0",
        height: "100%",
        width: "100%",
        opacity: "0",
        transition: ".3s ease",
        backgroundColor: "red"
      },
      ":hover": {
        opacity: "1",
        cursor: "pointer"
      }n
    };*/

    return (
      <div className={styles.container}>
        <img
          src={this.props.portfolioVal.imgUrl}
          alt="App"
          className={styles.image}
        ></img>
        <div className={styles.overlay}>
          <div className={styles.text}>
            {" "}
            <h2>{this.props.portfolioVal.title}</h2>
          </div>

          <div className={styles.icon}>
            {this.props.portfolioVal.iosUrl !== "" ? (
              <a
                className={styles.fauser}
                href={this.props.portfolioVal.iosUrl}
                target="blank"
                title="App Store"
              >
                <img
                  src="\images\apple.png"
                  className={styles.fauser}
                  width="50%"
                ></img>
              </a>
            ) : (
              ""
            )}
            {this.props.portfolioVal.androidUrl !== "" ? (
              <a
                className={styles.fauser}
                href={this.props.portfolioVal.androidUrl}
                target="blank"
                title="Google Play"
              >
                <img
                  src="\images\android.png"
                  className={styles.fauser}
                  width="50%"
                ></img>
              </a>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>

      /* <div>
        <img
          style={image}
          // width="10px"
          src={this.props.portfolioVal.imgUrl}
          alt="Card image"
          //style={{ maxWidth: " 15rem" }}
        ></img>

        <div class="card-img-overlay">
          <h5 class="card-text text-center">{this.props.portfolioVal.title}</h5>
          <Button
            className="card-button button-right"
            variant="outline-primary"
            target="blank"
            align="bottom"
            style={textblock}
            href={this.props.portfolioVal.androidUrl}
          >
            Android
          </Button>
          <Button
            align="center"
            variant="outline-primary"
            target="blank"
            style={{ margin: "10px" }}
            href={this.props.portfolioVal.iosUrl}
          >
            IOS
          </Button>
        </div>
      </div>*/
    );
  }
}

export default PortfolioCard;
